/* eslint-disable jsx-a11y/anchor-is-valid */
/* eslint-disable react-hooks/rules-of-hooks */
import { useState } from "react";
import "../adminCard.css";
import { Modal } from "react-bootstrap";

const ProfilePopupModal = ({ data, show, handleUpdateChef, handleDismiss, loading }) => {
  const [profilePicture, setProfilePicture] = useState(
    data.profileImage ? data.profileImage : ""
  );
  const [dragOver, setDragOver] = useState(false);
  const [triedImageUpload, setTriedImageUpload] = useState(false);

  const handleImageChange = (e) => {
    const file = e.target.files[0];
    if (file) {
      const reader = new FileReader();
      setTriedImageUpload(true);
      reader.onloadend = () => {
        setProfilePicture(reader.result);
      };
      reader.readAsDataURL(file);
    }
  };

  const handleDragOver = (e) => {
    e.preventDefault();
    setDragOver(true);
  };

  const handleDragLeave = (e) => {
    e.preventDefault();
    setDragOver(false);
  };

  const handleDrop = (e) => {
    e.preventDefault();
    setDragOver(false);
    const file = e.dataTransfer.files[0];
    if (file) {
      const reader = new FileReader();
      setTriedImageUpload(true);
      reader.onloadend = () => {
        setProfilePicture(reader.result);
      };
      reader.readAsDataURL(file);
    }
  };

  const handleClickUpload = () => {
    document.getElementById("fileInput").click();
  };

  const handleClose = () => {
    handleDismiss();
  };

  return (
    <Modal size="lg" show={show} backdrop="static">
      <Modal.Header>
        <Modal.Title>Add Chef Profile Picture</Modal.Title>
        <span onClick={handleClose}>&#10006;</span>
      </Modal.Header>
      <Modal.Body>
        <div className="custom-file-upload">
          <input
            type="file"
            accept="image/*"
            onChange={handleImageChange}
            className="form-control"
            id="fileInput"
          />
          <div
            className={`dropzone ${dragOver ? "dragover" : ""}`}
            onDragOver={handleDragOver}
            onDragLeave={handleDragLeave}
            onDrop={handleDrop}
            onClick={handleClickUpload}
          >
            {profilePicture ? (
              <img
                src={profilePicture}
                alt="Profile"
                className="mt-2 img-fluid"
                style={{ maxHeight: "200px" }}
              />
            ) : (
              <p>
                Drag & Drop or Click to Upload
                <br />
                <small>
                  Please select an image file (.png, .jpg, etc.)
                </small>
              </p>
            )}
          </div>
        </div>
      </Modal.Body>
      <Modal.Footer>
        {triedImageUpload && (
          <>
            <button
              type="button"
              className="btn btn-primary"
              onClick={() => handleUpdateChef(profilePicture)}
              disabled={loading}
            >
              {loading ? 'Uploading...' : 'Upload'}
            </button>
            <button
              type="button"
              className="btn btn-secondary"
              onClick={handleDismiss}
            >
              Close
            </button>
          </>
        )}
      </Modal.Footer>
    </Modal>
  );
};

export default ProfilePopupModal;
